import { useForm } from "react-hook-form";
import { AddIcon, DeleteIcon, EditIcon, HamburgerIcon } from '@chakra-ui/icons'
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, FormControl, FormLabel, IconButton, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDoorData } from '../context/DoorContext'

function CardGroupPage() {

  const { user, loading, axiosJWT, allCardGroups, getAllCardGroups } = useDoorData()
  const toast = useToast()
  const navigate = useNavigate()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenAlert, onOpen: onOpenAlert, onClose: onCloseAlert } = useDisclosure()
  const cancelRef = React.useRef()
  const { register, setValue, handleSubmit, formState: { isSubmitting }, reset } = useForm();
  const [editMode, setEditMode] = useState(false);
  const [editCardGroup, setEditCardGroup] = useState([]);
  const [deleteCardGroup, setDeleteCardGroup] = useState([]);

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user])

  useEffect(() => {
    getAllCardGroups()

  }, [])

  useEffect(() => {
    setValue('name', editCardGroup.name)

  }, [editCardGroup])


  const onSubmit = async data => {
      try {
        const res = await axiosJWT.put("/api/cardgroups/create", { name: data.name })
        if (res) {
          toast({
            title: '👋 Kortelių grupė sukurta!',
            position: 'bottom',
            status: 'success',
            isClosable: true,
            duration: 4000
          })
          getAllCardGroups();
          onClose();
          reset();

        }

      } catch (err) {
        console.log(err.response.data);
        toast({
          title: err.response.data,
          position: 'bottom',
          status: 'error',
          isClosable: true,
          duration: 4000
        })
      
    }

  };

  const onEdit = async data => {
      try {
        const res = await axiosJWT.put("/api/cardgroups/edit", { id: editCardGroup.id, name: data.name})
        if (res) {
          toast({
            title: '👋 Kortelių grupė redaguota!',
            position: 'bottom',
            status: 'success',
            isClosable: true,
            duration: 4000
          })
          getAllCardGroups();
          onClose();
          setEditCardGroup([])
          reset();

        }

      } catch (err) {
        console.log(err.response.data);
        toast({
          title: err.response.data,
          position: 'bottom',
          status: 'error',
          isClosable: true,
          duration: 4000
        })
        onClose();
        setEditCardGroup([])
      
    }



  };

  const handleDelete = async (userID) => {
    try {
      const res = await axiosJWT.delete(`/api/cardgroups/delete/${userID}`)
      if (res) {
        toast({
          title: '👋 Kortelių grupė ištrinta!',
          position: 'bottom',
          status: 'success',
          isClosable: true,
          duration: 4000
        })
        getAllCardGroups();
        setDeleteCardGroup([]);
        onCloseAlert();

      }

    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    }
  }



  return (
    <>
      <Button maxW={'12rem'} mx={'1rem'} leftIcon={<AddIcon />} onClick={() => { reset(); setEditCardGroup([]); setEditMode(false); onOpen(); }} colorScheme={'blue'}>Sukurti kortelių grupę</Button>



      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>

          <ModalHeader>{!editMode ? 'Sukurti kortelių grupę' : 'Redaguoti kortelių grupę'}</ModalHeader>

          <ModalCloseButton />
          <ModalBody m={'1rem'}>
            {loading ?
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='green.500'
                size='xl'
              />
              :
              <form onSubmit={!editMode ? handleSubmit(onSubmit) : handleSubmit(onEdit)}>
                <FormControl maxW={'30rem'} >
                  <FormLabel>Pavadinimas</FormLabel>
                  <Input autoComplete="off" mb={'1rem'} id='name' {...register("name", { required: true })} name='name' type='text' />
                  <Button mt={'1rem'} width={'100%'} colorScheme={'green'} isLoading={isSubmitting} type={'submit'} >{!editMode ? 'Sukurti kortelių grupę' : 'Redaguoti kortelių grupę'}</Button>
                </FormControl>
              </form>

            }




          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog
        isCentered
        isOpen={isOpenAlert}
        leastDestructiveRef={cancelRef}
        onClose={onCloseAlert}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              [{deleteCardGroup}] Ištrinti kortelių grupę?
            </AlertDialogHeader>

            <AlertDialogBody>
              Ar jūs įsitikinę? Šios kortelių grupės susigrąžinti nebegalėsite. Visi susije laikai taip pat bus ištrinti.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseAlert}>
                Atšaukti
              </Button>
              <Button colorScheme='red' onClick={() => handleDelete(deleteCardGroup)} ml={3}>
                Ištrinti
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>


      <>
        <TableContainer height={'70vh'} display={'block'} overflowY={'scroll'}>
          <Table variant='simple'>
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Pavadinimas</Th>
                <Th textAlign={'center'}>Veiksmai</Th>
              </Tr>
            </Thead>
            <Tbody>
              {allCardGroups.map((userRow, index) => {

                return (
                  <Tr key={index}>
                    <Td>{userRow.id}</Td>
                    <Td>{userRow.name}</Td>
                    <Td textAlign={'center'}><Menu>
                      <MenuButton
                        as={IconButton}
                        aria-label='Options'
                        icon={<HamburgerIcon />}
                        variant='outline'
                      />
                      <MenuList>
                        <MenuItem onClick={() => { setEditCardGroup(userRow); setEditMode(true); onOpen(); }} icon={<EditIcon />}>
                          Redaguoti
                        </MenuItem>
                        <MenuItem onClick={() => { setDeleteCardGroup(userRow.id); onOpenAlert() }} color={'red.500'} icon={<DeleteIcon />}>
                          Ištrinti
                        </MenuItem>
                      </MenuList>
                    </Menu></Td>
                  </Tr>
                )







              })}

            </Tbody>
          </Table>
        </TableContainer>



      </>



    </>
  )
}

export default CardGroupPage